

























import { Component, Vue, Prop } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import KnowledgeChunks from '@/trials/domain/objects/knowledgeChunks';
import SingleSelectDataTable from '@/trials/views/components/SingleSelectDataTable.vue';
import KCSummary from '@/trials/views/components/KCSummary.vue';

@Component({ components: { SingleSelectDataTable, KCSummary } })
export default class KCListAndDetail extends Vue {
    /*----------------------------------*
     * Props
     *-----------------------------------*/
    @Prop({ required: true })
    private tableData: any[];

    @Prop({ required: true })
    private kcList: KnowledgeChunks | null;

    @Prop({ required: true })
    private selectHandler: Function | null;

    @Prop({ default: false })
    private withResult: boolean;

    @Prop({ default: 0 })
    private selectedIndex: number;
    /*----------------------------------*
     * Data
     *-----------------------------------*/
    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    public get showKCSummary(): boolean {
        return this.kcList !== null;
    }
    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    /*----------------------------------*
     * Methods
     *-----------------------------------*/
}
